import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/social")({
  component: () => <Outlet />,
  head: () => ({ meta: [{ title: "Social media · Admin" }, { name: "robots", content: "noindex" }] }),
});
